// extracted by mini-css-extract-plugin
module.exports = {"row":"row___2EHTS","title":"title___3azsF","right":"right___hzhEk"};